/**
 * @generated SignedSource<<ed9898936bcae7d89b360908a4849ca3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksNewsletterScrollEffectNewsletterCategoryConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly entityId: string;
    };
  }>;
  readonly " $fragmentType": "hooksNewsletterScrollEffectNewsletterCategoryConnection";
};
export type hooksNewsletterScrollEffectNewsletterCategoryConnection$key = {
  readonly " $data"?: hooksNewsletterScrollEffectNewsletterCategoryConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksNewsletterScrollEffectNewsletterCategoryConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksNewsletterScrollEffectNewsletterCategoryConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NewsletterCategoryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NewsletterCategory",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NewsletterCategoryConnection",
  "abstractKey": null
};

(node as any).hash = "bbea56bdfde38cd0a4a8628980b5ee9b";

export default node;
